import digitalTechnologiesAtTheStageOfPatientCommunicationRu from "./articlesListAssets/1/digital-technologies-at-the-stage-of-patient-communication-ru";
import digitalTechnologiesAtTheStageOfPatientCommunication from "./articlesListAssets/1/digital-technologies-at-the-stage-of-patient-communication";
import art2ru from "./articlesListAssets/2/art2-ru";
import art2en from "./articlesListAssets/2/art2-en";
import art3ru from "./articlesListAssets/3/art3-ru";
import art3en from "./articlesListAssets/3/art3-en";
import art4ru from "./articlesListAssets/4/art4-ru";
import art4en from "./articlesListAssets/4/art4-en";
import art5ru from "./articlesListAssets/5/art5-ru";
import art5en from "./articlesListAssets/5/art5-en";
import art6ru from "./articlesListAssets/6/art6-ru";
import art6en from "./articlesListAssets/6/art6-en";
import art7ru from "./articlesListAssets/7/art7-ru";
import art7en from "./articlesListAssets/7/art7-en";
import art8ru from "./articlesListAssets/8/art8-ru";
import art8en from "./articlesListAssets/8/art8-en";
import art9ru from "./articlesListAssets/9/art9-ru";
import art9en from "./articlesListAssets/9/art9-en";
import art10ru from "./articlesListAssets/10/art10-ru";
import art10en from "./articlesListAssets/10/art10-en";
import art11ru from "./articlesListAssets/11/art11-ru";
import art11en from "./articlesListAssets/11/art11-en";
import art12ru from "./articlesListAssets/12/art12-ru";
import art12en from "./articlesListAssets/12/art12-en";
import art13ru from "./articlesListAssets/13/art13-ru";
import art13en from "./articlesListAssets/13/art13-en";
import art14ru from "./articlesListAssets/14/art14-ru";
import art14en from "./articlesListAssets/14/art14-en";
import art15ru from "./articlesListAssets/15/art15-ru";
import art15en from "./articlesListAssets/15/art15-en";

const articlesListData = [
  // 15
  {
    language: "uk",
    url: "digital-consultation-protocol-uk",
    title: "Протокол консультации пациента при помощи цифровых технологий с использованием приложения Dental Bot.",
    keywords: "протокол консультации пациента, цифровые технологий, расчеты стоимости лечения, цифровой протокол",
    bg: require("./articlesListAssets/15/digital_consultation_protocol.jpg"),
    video: require("./articlesListAssets/15/digital_consultation_protocol-ru.mp4"),
    content: art15ru,
    date: "05.29.2021",
  },
  {
    language: "ru",
    url: "digital-consultation-protocol-ru",
    title: "Протокол консультации пациента при помощи цифровых технологий с использованием приложения Dental Bot.",
    keywords: "протокол консультации пациента, цифровые технологий, расчеты стоимости лечения, цифровой протокол",
    bg: require("./articlesListAssets/15/digital_consultation_protocol.jpg"),
    video: require("./articlesListAssets/15/digital_consultation_protocol-ru.mp4"),
    content: art15ru,
    date: "05.29.2021",
  },
  {
    language: "en",
    url: "digital-consultation-protocol",
    title: "Digital patient consultation protocol using the Dental Bot app.",
    keywords: "dental protocol, patient consultation protocol, digital technologies, digital protocol",
    bg: require("./articlesListAssets/15/digital_consultation_protocol.jpg"),
    video: require("./articlesListAssets/15/digital_consultation_protocol-en.mp4"),
    content: art15en,
    date: "05.29.2021",
  },

  // 14
  {
    language: "uk",
    url: "smart-invoice-uk",
    title: "Функция Smart Счет. Финансовые планы лечения.",
    keywords: "стоматологический калькулятор, финансовые планы лечения, счет за протезирование, протезирование зубов",
    bg: require("./articlesListAssets/14/smart_invoice.jpg"),
    video: require("./articlesListAssets/14/smart_invoice_ru.mp4"),
    content: art14ru,
    date: "12.04.2021",
  },
  {
    language: "ru",
    url: "smart-invoice-ru",
    title: "Функция Smart Счет. Финансовые планы лечения.",
    keywords: "стоматологический калькулятор, финансовые планы лечения, счет за протезирование, протезирование зубов",
    bg: require("./articlesListAssets/14/smart_invoice.jpg"),
    video: require("./articlesListAssets/14/smart_invoice_ru.mp4"),
    content: art14ru,
    date: "12.04.2021",
  },
  {
    language: "en",
    url: "smart-invoice",
    title: "Smart Invoice function. Financial treatment plans.",
    keywords: "dental calculator, financial treatment plans, prosthetics invoice, dental prosthetics",
    bg: require("./articlesListAssets/14/smart_invoice.jpg"),
    video: require("./articlesListAssets/14/smart_invoice_en.mp4"),
    content: art14en,
    date: "12.04.2021",
  },

  // 13
  {
    language: "uk",
    url: "media-library-uk",
    title: "Мотивационный контент модуля Медиатека",
    keywords: "медиатека, стоматологические видео, мотивационные фото, 3D визуализации зубов",
    bg: require("./articlesListAssets/13/mediaLibrary.jpg"),
    video: require("./articlesListAssets/13/mediaLibrary-ru.mp4"),
    content: art13ru,
    date: "01.03.2020",
  },
  {
    language: "ru",
    url: "media-library-ru",
    title: "Мотивационный контент модуля Медиатека",
    keywords: "медиатека, стоматологические видео, мотивационные фото, 3D визуализации зубов",
    bg: require("./articlesListAssets/13/mediaLibrary.jpg"),
    video: require("./articlesListAssets/13/mediaLibrary-ru.mp4"),
    content: art13ru,
    date: "01.03.2020",
  },
  {
    language: "en",
    url: "media-library",
    title: "Motivational content of the Media Library module",
    keywords: "media library, dental videos, motivational photos, 3D dental visualizations",
    bg: require("./articlesListAssets/13/mediaLibrary.jpg"),
    video: require("./articlesListAssets/13/mediaLibrary-en.mp4"),
    content: art13en,
    date: "01.03.2020",
  },

  // 12
  {
    language: "uk",
    url: "patient-use-uk",
    title: "Как пациент может самостоятельно использовать приложение Dental Bot 3D",
    keywords: "программа Dental Bot 3D, использовать систему Dental Bot 3D",
    bg: require("./articlesListAssets/12/patientUse.jpg"),
    video: require("./articlesListAssets/12/patientUse-ru.mp4"),
    content: art12ru,
    date: "31.10.2020",
  },
  {
    language: "ru",
    url: "patient-use-ru",
    title: "Как пациент может самостоятельно использовать приложение Dental Bot 3D",
    keywords: "программа Dental Bot 3D, использовать систему Dental Bot 3D",
    bg: require("./articlesListAssets/12/patientUse.jpg"),
    video: require("./articlesListAssets/12/patientUse-ru.mp4"),
    content: art12ru,
    date: "31.10.2020",
  },
  {
    language: "en",
    url: "patient-use",
    title: "How a patient can independently use the Dental Bot 3D app",
    keywords: "Dental Bot 3D program, use the Dental Bot 3D system",
    bg: require("./articlesListAssets/12/patientUse.jpg"),
    video: require("./articlesListAssets/12/patientUse-en.mp4"),
    content: art12en,
    date: "31.10.2020",
  },

  // 11
  {
    language: "uk",
    url: "online-consultation-uk",
    title: "Онлайн презентация планов лечения при помощи приложения Dental Bot 3D",
    keywords: "онлайн презентации планов лечения, презентовать план лечения пациенту",
    bg: require("./articlesListAssets/11/onlineConsultation.jpg"),
    video: require("./articlesListAssets/11/onlineConsultation-ru.mp4"),
    content: art11ru,
    date: "30.10.2020",
  },
  {
    language: "ru",
    url: "online-consultation-ru",
    title: "Онлайн презентация планов лечения при помощи приложения Dental Bot 3D",
    keywords: "онлайн презентации планов лечения, презентовать план лечения пациенту",
    bg: require("./articlesListAssets/11/onlineConsultation.jpg"),
    video: require("./articlesListAssets/11/onlineConsultation-ru.mp4"),
    content: art11ru,
    date: "30.10.2020",
  },
  {
    language: "en",
    url: "online-consultation",
    title: "Online presentation of treatment plans using the Dental Bot 3D app ",
    keywords: "online presentation of treatment plans, present the treatment plan to the patient",
    bg: require("./articlesListAssets/11/onlineConsultation.jpg"),
    video: require("./articlesListAssets/11/onlineConsultation-en.mp4"),
    content: art11en,
    date: "30.10.2020",
  },

  //10
  {
    language: "uk",
    url: "complex-prosthetics-plan-uk",
    title: "Как визуализировать комплексный план протезирования при помощи приложения Dental Bot 3D",
    keywords: "комплексный план реабилитации",
    bg: require("./articlesListAssets/10/ComplexProstheticsPlan.jpg"),
    video: require("./articlesListAssets/10/ComplexProstheticsPlan-ru.mp4"),
    content: art10ru,
    date: "29.10.2020",
  },
  {
    language: "ru",
    url: "complex-prosthetics-plan-ru",
    title: "Как визуализировать комплексный план протезирования при помощи приложения Dental Bot 3D",
    keywords: "комплексный план реабилитации",
    bg: require("./articlesListAssets/10/ComplexProstheticsPlan.jpg"),
    video: require("./articlesListAssets/10/ComplexProstheticsPlan-ru.mp4"),
    content: art10ru,
    date: "29.10.2020",
  },
  {
    language: "en",
    url: "complex-prosthetics-plan",
    title: "How to visualize a comprehensive rehabilitation plan for a patient using the Dental Bot 3D app",
    keywords: "comprehensive rehabilitation plan",
    bg: require("./articlesListAssets/10/ComplexProstheticsPlan.jpg"),
    video: require("./articlesListAssets/10/ComplexProstheticsPlan-en.mp4"),
    content: art10en,
    date: "29.10.2020",
  },

  // 9
  {
    language: "uk",
    url: "implantation-as-an-alternative-complete-removable-prosthesis-uk",
    title:
      "Как смотивировать пациента на имплантацию, если тот убежден в правильности выбора съемного протеза при полной адентии",
    keywords: "тотальное протезирование на имплантах",
    bg: require("./articlesListAssets/9/CompleteRemovable-Implantation.jpg"),
    video: require("./articlesListAssets/9/CompleteRemovable-Implantation-ru.mp4"),
    content: art9ru,
    date: "28.10.2020",
  },
  {
    language: "ru",
    url: "implantation-as-an-alternative-complete-removable-prosthesis-ru",
    title:
      "Как смотивировать пациента на имплантацию, если тот убежден в правильности выбора съемного протеза при полной адентии",
    keywords: "тотальное протезирование на имплантах",
    bg: require("./articlesListAssets/9/CompleteRemovable-Implantation.jpg"),
    video: require("./articlesListAssets/9/CompleteRemovable-Implantation-ru.mp4"),
    content: art9ru,
    date: "28.10.2020",
  },
  {
    language: "en",
    url: "implantation-as-an-alternative-complete-removable-prosthesis",
    title:
      "How to motivate a patient for implantation, if he is convinced of the correct choice of a removable prosthesis with complete adentia",
    keywords: "total prosthetics on implants",
    bg: require("./articlesListAssets/9/CompleteRemovable-Implantation.jpg"),
    video: require("./articlesListAssets/9/CompleteRemovable-Implantation-en.mp4"),
    content: art9en,
    date: "28.10.2020",
  },

  // 8
  {
    language: "uk",
    url: "fix-to-implants-full-adentia-uk",
    title: "Как визуализировать для пациента типы конструкций на имплантах при полной адентии",
    keywords: "зубные импланты",
    bg: require("./articlesListAssets/8/FullAdentia.jpg"),
    video: require("./articlesListAssets/8/FixToImplFullAdentia-ru.mp4"),
    content: art8ru,
    date: "27.10.2020",
  },
  {
    language: "ru",
    url: "fix-to-implants-full-adentia-ru",
    title: "Как визуализировать для пациента типы конструкций на имплантах при полной адентии",
    keywords: "зубные импланты",
    bg: require("./articlesListAssets/8/FullAdentia.jpg"),
    video: require("./articlesListAssets/8/FixToImplFullAdentia-ru.mp4"),
    content: art8ru,
    date: "27.10.2020",
  },
  {
    language: "en",
    url: "fix-to-implants-full-adentia",
    title: "How to visualize for the patient types of constructions on implants with complete adentia",
    keywords: "dental implants",
    bg: require("./articlesListAssets/8/FullAdentia.jpg"),
    video: require("./articlesListAssets/8/FixToImplFullAdentia-en.mp4"),
    content: art8en,
    date: "27.10.2020",
  },

  // 7
  {
    language: "uk",
    url: "aesthetic-module-uk",
    title:
      "Как подготовить пациента к винирингу и тотальной реставрации зубов коронками при помощи приложения Dental Bot 3D",
    keywords: "виниры, зубные коронки",
    bg: require("./articlesListAssets/7/aestheticModule.jpg"),
    video: require("./articlesListAssets/7/aestheticModule-ru.mp4"),
    content: art7ru,
    date: "25.10.2020",
  },
  {
    language: "ru",
    url: "aesthetic-module-ru",
    title:
      "Как подготовить пациента к винирингу и тотальной реставрации зубов коронками при помощи приложения Dental Bot 3D",
    keywords: "виниры, зубные коронки",
    bg: require("./articlesListAssets/7/aestheticModule.jpg"),
    video: require("./articlesListAssets/7/aestheticModule-ru.mp4"),
    content: art7ru,
    date: "25.10.2020",
  },
  {
    language: "en",
    url: "aesthetic-module",
    title:
      "How to prepare a patient for veneering and total restoration of teeth with crowns using the Dental Bot 3D app",
    keywords: "veneers, dental crowns",
    bg: require("./articlesListAssets/7/aestheticModule.jpg"),
    video: require("./articlesListAssets/7/aestheticModule-en.mp4"),
    content: art7en,
    date: "25.10.2020",
  },

  // 6
  {
    language: "uk",
    url: "implantation-alternative-to-dental-bridges-uk",
    title: "Как мотивировать пациента на имплантацию, если тот убежден в правильности выбора съемного протеза",
    keywords: "имплантация зубов",
    bg: require("./articlesListAssets/6/Removable-Implantation.jpg"),
    video: require("./articlesListAssets/6/Removable-Implantation-ru.mp4"),
    content: art6ru,
    date: "24.10.2020",
  },
  {
    language: "ru",
    url: "implantation-alternative-to-dental-bridges-ru",
    title: "Как мотивировать пациента на имплантацию, если тот убежден в правильности выбора съемного протеза",
    keywords: "имплантация зубов",
    bg: require("./articlesListAssets/6/Removable-Implantation.jpg"),
    video: require("./articlesListAssets/6/Removable-Implantation-ru.mp4"),
    content: art6ru,
    date: "24.10.2020",
  },
  {
    language: "en",
    url: "implantation-alternative-to-dental-bridges",
    title: "How to motivate a patient for implantation if he is convinced of the correct choice of a removable denture",
    keywords: "dental implantation",
    bg: require("./articlesListAssets/6/Removable-Implantation.jpg"),
    video: require("./articlesListAssets/6/Removable-Implantation-en.mp4"),
    content: art6en,
    date: "24.10.2020",
  },

  // 5
  {
    language: "uk",
    url: "implantation-alternative-to-dental-bridges-uk",
    title: "Как мотивировать пациента на имплантацию, если тот убежден в правильности выбора мостовидного протеза",
    keywords: "варианты протезирования зубов",
    bg: require("./articlesListAssets/5/Bridged-Implantation.jpg"),
    video: require("./articlesListAssets/5/Bridged-Implantation-ru.mp4"),
    content: art5ru,
    date: "23.10.2020",
  },
  {
    language: "ru",
    url: "implantation-alternative-to-dental-bridges-ru",
    title: "Как мотивировать пациента на имплантацию, если тот убежден в правильности выбора мостовидного протеза",
    keywords: "варианты протезирования зубов",
    bg: require("./articlesListAssets/5/Bridged-Implantation.jpg"),
    video: require("./articlesListAssets/5/Bridged-Implantation-ru.mp4"),
    content: art5ru,
    date: "23.10.2020",
  },
  {
    language: "en",
    url: "implantation-alternative-to-dental-bridges",
    title: "How to motivate a patient for implantation if he is convinced of the correct choice of a dental bridge",
    keywords: "dental prosthetics options",
    bg: require("./articlesListAssets/5/Bridged-Implantation.jpg"),
    video: require("./articlesListAssets/5/Bridged-Implantation-en.mp4"),
    content: art5en,
    date: "23.10.2020",
  },

  // 4
  {
    language: "uk",
    url: "doctors-panel-in-the-app-uk",
    title: "Как пользоваться сохраненными результатами консультаций пациентов",
    keywords: "план стоматологического лечения",
    bg: require("./articlesListAssets/4/doctor'sPanel.jpg"),
    video: require("./articlesListAssets/4/doctor'sPanelInTheApp-ru.mp4"),
    content: art4ru,
    date: "22.10.2020",
  },
  {
    language: "ru",
    url: "doctors-panel-in-the-app-ru",
    title: "Как пользоваться сохраненными результатами консультаций пациентов",
    keywords: "план стоматологического лечения",
    bg: require("./articlesListAssets/4/doctor'sPanel.jpg"),
    video: require("./articlesListAssets/4/doctor'sPanelInTheApp-ru.mp4"),
    content: art4ru,
    date: "22.10.2020",
  },
  {
    language: "en",
    url: "doctors-panel-in-the-app",
    title: "How to use saved patient consultation results",
    keywords: "dental treatment plan",
    bg: require("./articlesListAssets/4/doctor'sPanel.jpg"),
    video: require("./articlesListAssets/4/doctor'sPanelInTheApp-en.mp4"),
    content: art4en,
    date: "22.10.2020",
  },

  // 3
  {
    language: "uk",
    url: "types-of-fixation-to-implant-partial-adentia-uk",
    title: "Демонстрация типов фиксации протезов к имплантам при частичной адентии",
    keywords: "варианты протезирования на имплантах",
    bg: require("./articlesListAssets/3/typesOfFixation.jpg"),
    video: require("./articlesListAssets/3/typesOfFixationToImplantPartialAdentia-ru.mp4"),
    content: art3ru,
    date: "21.10.2020",
  },
  {
    language: "ru",
    url: "types-of-fixation-to-implant-partial-adentia-ru",
    title: "Демонстрация типов фиксации протезов к имплантам при частичной адентии",
    keywords: "варианты протезирования на имплантах",
    bg: require("./articlesListAssets/3/typesOfFixation.jpg"),
    video: require("./articlesListAssets/3/typesOfFixationToImplantPartialAdentia-ru.mp4"),
    content: art3ru,
    date: "21.10.2020",
  },
  {
    language: "en",
    url: "types-of-fixation-to-implant-partial-adentia",
    title: "Types of fixation of prostheses to implants",
    keywords: "options for prosthetics on implants",
    bg: require("./articlesListAssets/3/typesOfFixation.jpg"),
    video: require("./articlesListAssets/3/typesOfFixationToImplantPartialAdentia-en.mp4"),
    content: art3en,
    date: "21.10.2020",
  },

  // 2
  {
    language: "uk",
    url: "accounts-dashboard-uk",
    title: "Как пользоваться панелью управления аккаунтами на сайте dentalbot.pro",
    keywords: "стоматологическое приложение, обучающий стоматологический контент",
    bg: require("./articlesListAssets/2/Dashboard.jpg"),
    video: require("./articlesListAssets/2/accountsDashboard-ru.mp4"),
    content: art2ru,
    date: "20.10.2020",
  },
  {
    language: "ru",
    url: "accounts-dashboard-ru",
    title: "Как пользоваться панелью управления аккаунтами на сайте dentalbot.pro",
    keywords: "стоматологическое приложение, обучающий стоматологический контент",
    bg: require("./articlesListAssets/2/Dashboard.jpg"),
    video: require("./articlesListAssets/2/accountsDashboard-ru.mp4"),
    content: art2ru,
    date: "20.10.2020",
  },
  {
    language: "en",
    url: "accounts-dashboard ",
    title: "How to use the account dashboard on dentalbot.pro",
    keywords: "dental app, dental content",
    bg: require("./articlesListAssets/2/Dashboard.jpg"),
    video: require("./articlesListAssets/2/accountsDashboard-en.mp4"),
    content: art2en,
    date: "20.10.2020",
  },

  // 1
  {
    language: "uk",
    url: "digital-technologies-at-the-stage-of-patient-communication-uk",
    title: "Цифровые технологии на этапе коммуникации с пациентом",
    keywords: "цифровые",
    bg: require("./articlesListAssets/1/bg.jpg"),
    content: digitalTechnologiesAtTheStageOfPatientCommunicationRu,
    date: "02.10.2020",
  },
  {
    language: "ru",
    url: "digital-technologies-at-the-stage-of-patient-communication-ru",
    title: "Цифровые технологии на этапе коммуникации с пациентом",
    keywords: "цифровые",
    bg: require("./articlesListAssets/1/bg.jpg"),
    content: digitalTechnologiesAtTheStageOfPatientCommunicationRu,
    date: "02.10.2020",
  },
  {
    language: "en",
    url: "digital-technologies-at-the-stage-of-patient-communication",
    title: "Digital technologies at the stage of patient communication",
    keywords: "digital",
    bg: require("./articlesListAssets/1/bg.jpg"),
    content: digitalTechnologiesAtTheStageOfPatientCommunication,
    date: "02.10.2020",
  },
];

export default articlesListData;
